import clsx from 'clsx';
import _ from 'lodash';
import { isNewHomeScreen2025Enabled } from '@/services/systemConfiguration.utilities';
import { faCaretLeft, faCaretRight } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, Paginator as QomponentsPaginator } from '@seeqdev/qomponents';

interface PaginatorProps {
  gotoPage: (page: number) => void;
  pageCount: number;
  pageNumber: number;
  pageSize?: number;
  setPageSize?: (size: number) => void;
  insideModal?: boolean;
  total?: number;
  pageSizeOptionsCustom?: number[];
  small?: boolean;
  allowCustomPageSize?: boolean;
}

export const Paginator = ({
  gotoPage,
  pageCount,
  pageNumber,
  pageSize,
  setPageSize = _.noop,
  insideModal = false,
  total,
  pageSizeOptionsCustom,
  small = false,
  allowCustomPageSize = false,
}: PaginatorProps) => {
  return (
    <div className={`${isNewHomeScreen2025Enabled() ? '' : 'paginatorWrapper'}`}>
      <div className={clsx('paginator', 'flexColumnContainerWrap', small ? 'tw:mr-1.25' : 'tw:m-1 tw:mx-3')}>
        <QomponentsPaginator
          pageCount={pageCount}
          pageNumber={pageNumber}
          pageSize={pageSize}
          variant={insideModal ? 'compact' : 'normal'}
          total={total}
          pageSizeOptions={pageSizeOptionsCustom}
          size={small ? 'small' : 'normal'}
          creatablePageSizes={allowCustomPageSize}
          previousLabel={insideModal ? <Icon icon={faCaretLeft} /> : undefined}
          nextLabel={insideModal ? <Icon icon={faCaretRight} /> : undefined}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          activeClassName="active"
          containerClassName={clsx('pagination', small ? 'pagination-small' : 'pagination-lg', {
            newHomeScreenPagination: isNewHomeScreen2025Enabled(),
          })}
          onPageChange={gotoPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};
